var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSevere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4004_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 27.7183V28.1855L59.8825 28.4199C59.9221 28.5503 59.9602 28.707 59.9997 28.8872V31.2266L59.8825 31.6938C59.9323 31.7246 59.9719 31.8022 59.9997 31.9282V32.5127C59.3434 47.0937 46.4232 59.5347 32.1626 59.9946H31.6953C31.6118 59.9448 31.5503 59.9609 31.4609 59.9946H30.5249C30.1836 59.8936 29.8129 59.8936 29.4716 59.9946H28.6528C28.5693 59.9448 28.5077 59.9609 28.4184 59.9946C28.2265 59.9829 28.0258 60.0107 27.8339 59.9946C14.3365 59.6519 2.92361 48.7681 0.481659 35.7456C-0.162888 32.312 -0.171678 27.1309 0.506562 23.7046C2.72732 12.4824 12.1978 3.03711 23.344 0.598143C27.2875 -0.26465 33.1514 -0.184083 37.0729 0.775389C49.4716 3.80615 59.6452 14.6724 59.9997 27.7183Z",
    fill: "#E11B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5259 59.994H29.4727C29.6909 59.7963 30.3076 59.7963 30.5259 59.994Z",
    fill: "#E74A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 28.8884C59.83 28.8093 59.8783 28.5734 59.8827 28.4211C59.9164 28.3185 59.9545 28.32 59.9999 28.4211V28.8884Z",
    fill: "#EA6363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9994 31.6948C59.9657 31.7974 59.9276 31.7959 59.8822 31.6948C59.8719 31.5454 59.8338 31.3037 59.9994 31.2275V31.6948Z",
    fill: "#EA6363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 28.4199H59.8828C59.8857 28.3203 59.8901 28.2192 60 28.1855V28.4199Z",
    fill: "#EF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 31.9277C59.8872 31.894 59.8901 31.793 59.8828 31.6934H60V31.9277Z",
    fill: "#EF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6543 59.9941H28.4199L28.5606 59.915L28.6543 59.9941Z",
    fill: "#F08D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6953 59.9941H31.4609L31.6016 59.915L31.6953 59.9941Z",
    fill: "#F08D8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4327 16.0371L30.016 25.3711L39.4981 16.0371L39.8307 16.1338L44.0393 20.3525L44.0979 20.5269L43.9836 20.7656L34.7461 30.0146L44.0817 39.4951L43.9836 39.8276L39.7647 44.0361L39.5919 44.0947L39.3516 43.9805L30.1009 34.7432L20.6276 44.0815L16.0747 39.646L25.3723 30.0996L16.0352 20.6191L16.1333 20.2866L20.4327 16.0371Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4004_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSevere);
export default __webpack_public_path__ + "static/media/severe.cb93133383ac5f3a6e0d3871020674d5.svg";
export { ForwardRef as ReactComponent };